<rtc-detached-router-outlet></rtc-detached-router-outlet>
